import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  public person={
    phone:'+91 7566665551',
    address:'B-16/3 Mahananda Nagar, Ujjain(M.P.)',
    addressPart1:'B-16/3 Mahananda Nagar',
    addressPart2:'Near Shahnai Garden',
    addressPart3:'Ujjain M.P.',
    firstName:'Aditya',
    name:'Aditya Vandan Sharma',
    email:'adityavandan@outlook.com',
    linkedin:'https://www.linkedin.com/in/aditya-vandan-sharma-74a941132/',
    github:'https://github.com/AdityaVandan',
    instagram:'https://www.instagram.com/da.1.who.knocks/',
    skype:'',
    google:'',
    facebook:'https://www.facebook.com/Van13Heisenberg',
    medium:'',
    engineering:{
        level:'Bachelor of Engineering',
        marks:'6.94',
        marksType:'CGPA',
        school:'Ujjain Engineering College (previously known as Govt. Engineering College, Ujjain)',
        start:'June 2016',
        end:'May 2020'
      },
      class12:{
        level:'12th',
        marks:'79.4',
        marksType:'Percentage',
        school:'St. Mary\'s Convent School, Ujjain',
        start:'April 2014',
        end:'March 2015'
      },
      class10:{
        level:'10th',
        marks:'7.6',
        marksType:'CGPA',
        school:'St. Mary\'s Convent School, Ujjain',
        start:'April 2012',
        end:'March 2013'
      },
      internExp:[
        {
        designation:'Data Engineering Intern',
        company:'Almug.ai',
        place:'Bangalore',
        start:'May 2020',
        end:'Present',
        about:"Design and implementation of data processing elements in a data pipeline, Optimising algorithms for removing road blocks in a data pipeline, Implementing a software/engine as a Service, Automating testing for increasing efficiency of work"
      },
      {
        designation:'Full Stack Engineering Intern',
        company:'Codensious.ai',
        place:'Indore',
        start:'May 2019',
        end:'August 2019',
        about:"Design, implementation and testing of RESTful APIs in Django. Design and implementation of responsive pages using JavaScript, bootstrap and Django Templates. Design and implementation of a TCP/IP network architecture between systems. Research and integration with third-party APIs. Database design for storing data accumulated from different APIs."
      }
    ],
      skillSectionNote:'While learning breadth-first search can do the trick... I believe the core algorithm that we must apply while learning an import ant skill is depth first search'
  };
  getPerson()
  {
    return this.person;
  }

  constructor() { }
}
